export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "/api/user";
